import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export const RETRANSMITIR_BPE_RESERVA = '@configuraBPeAction/RETRANSMITIR_BPE_RESERVA';

export default function retransmitirBpeReserva(codigo, codigoEmpresa) {
    const url = `${URL}/reserva/retransmitir-bpe?idsReserva=${codigo}&empresaId=${codigoEmpresa}`;
    
    return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: RETRANSMITIR_BPE_RESERVA,
        payload: response
      })
    );
  }